export default __webpack_public_path__ + "static/media/GrantAnswer.76316e6c.png";